import { CloseIcon } from '@/assets/icons/close.icon';
import { useAnalytics } from '../../hooks/useAnalytics.hook';
import { decodeDotKey } from '@/core/utils/encode-decode';
import _ from 'lodash';

const FiltersBar = () => {
  const { filters, updateFilter } = useAnalytics();
  const { source, country, device, browser, os } = filters;

  const decodedSource = decodeDotKey(source);
  const match = decodedSource.match(/^([^\[]+)\[([^\]]+)\]$/) || '';

  const filterEntries: { key: keyof typeof filters; label: string; value: string | undefined }[] = [
    { key: 'source', label: 'Source', value: source === 'Direct' ? 'Direct' : match[1] },
    { key: 'country', label: 'Country', value: country },
    { key: 'device', label: 'Device', value: _.capitalize(device) },
    { key: 'browser', label: 'Browser', value: browser },
    { key: 'os', label: 'OS', value: os },
  ];

  const activeFilters = filterEntries.filter((f) => f.value);

  if (activeFilters.length === 0) return null;

  return (
    <div className="fixed bottom-5 left-1/2 transform -translate-x-1/2 flex flex-col md:flex-row items-center justify-center space-x-0 md:space-x-1 space-y-1 md:space-y-0">
      {activeFilters.map((filter, idx) => (
        <div key={idx} className="p-[1px] rounded-xl bg-gradient-to-b from-[#3E4046] to-[#2A2A2A]">
          <div className="flex items-center justify-center text-sm text-lighter bg-[#18191C] rounded-[10px] px-4 py-2">
            {`${filter.label}: ${filter.value}`}
            <div
              className="ml-2 cursor-pointer"
              onClick={() => {
                updateFilter(filter.key, '');
              }}
            >
              <CloseIcon className="size-4" fill="#3C3E44" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FiltersBar;
